"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { ColorBlock } from "@repo/ui/color-block";
import { Carousel, CarouselContent, CarouselItem, CarouselPrevious, CarouselNextWithProgress, useCarousel } from "@repo/ui/carousel";
import { cn } from "@repo/ui/utils";
import { isDarkBackground } from "@/lib/color-utils";
import { VisualWrapper } from "@/components/common/visual/visual.component";
import { RichTextCondensed } from "@/components/common/rich-text/rich-text-condensed.component";
import type { DistrictMapCarouselProps, DistrictMapCarouselCard } from "./district-map-carousel.types";
export function DistrictMapCarousel(t0) {
  const $ = _c(5);
  const {
    districts,
    className
  } = t0;
  let t1;
  if ($[0] !== districts) {
    t1 = <DistrictCarouselInner districts={districts} />;
    $[0] = districts;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== className || $[3] !== t1) {
    t2 = <Carousel align="start" loop={true} duration={40} className={className}>{t1}</Carousel>;
    $[2] = className;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function DistrictCarouselInner(t0) {
  const $ = _c(44);
  const {
    districts
  } = t0;
  const {
    api
  } = useCarousel();
  const [settledIndex, setSettledIndex] = useState(0);
  const total = districts.length;
  const active = districts[settledIndex];
  let t1;
  if ($[0] !== districts) {
    t1 = districts.some(_temp);
    $[0] = districts;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hasMaps = t1;
  let t2;
  let t3;
  if ($[2] !== api) {
    t2 = () => {
      if (!api) {
        return;
      }
      const onSelect = () => setSettledIndex(api.selectedScrollSnap());
      api.on("select", onSelect);
      return () => {
        api.off("select", onSelect);
      };
    };
    t3 = [api];
    $[2] = api;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  if (!active) {
    return null;
  }
  const colour = active.colour ?? "cobalt";
  const isDark = isDarkBackground(colour);
  const textColor = isDark ? "text-white" : "text-deep-sea-blue-500";
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex items-center gap-2"><CarouselPrevious /><CarouselNextWithProgress autoplayDelay={6000} /></div>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const navigation = t4;
  let t5;
  if ($[6] !== districts) {
    t5 = districts.map(_temp2);
    $[6] = districts;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <div className="relative aspect-[390/267] w-full overflow-hidden mobile:absolute mobile:inset-0 mobile:aspect-auto [&>div]:h-full"><CarouselContent className="h-full -ml-0">{t5}</CarouselContent></div>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== districts || $[11] !== settledIndex || $[12] !== textColor) {
    let t8;
    if ($[14] !== settledIndex || $[15] !== textColor) {
      t8 = (district_1, idx) => <div key={district_1.key} aria-hidden={idx !== settledIndex} inert={idx !== settledIndex ? true : undefined} className={cn("col-start-1 row-start-1 flex flex-col gap-6 transition-opacity duration-500", idx === settledIndex ? "opacity-100" : "opacity-0 pointer-events-none")}>{district_1.headline && <h3 className={cn("typography-mobile-heading-h5 tablet:typography-desktop-heading-h5", textColor)}>{district_1.headline}</h3>}{district_1.bodyCopy && <RichTextCondensed richText={district_1.bodyCopy} as="body-medium-tablet" compact={true} className={textColor} />}</div>;
      $[14] = settledIndex;
      $[15] = textColor;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    t7 = districts.map(t8);
    $[10] = districts;
    $[11] = settledIndex;
    $[12] = textColor;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[17] !== t7) {
    t8 = <div className="grid">{t7}</div>;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== districts || $[20] !== hasMaps || $[21] !== settledIndex) {
    t9 = hasMaps && <div className="relative aspect-[358/154] w-full overflow-clip rounded-sm tablet:max-w-[358px] tablet:aspect-[358/180]">{districts.map((district_2, idx_0) => district_2.mapVisual ? <div key={district_2.key} aria-hidden={idx_0 !== settledIndex} inert={idx_0 !== settledIndex ? true : undefined} className={cn("absolute inset-0 transition-opacity duration-500", idx_0 === settledIndex ? "opacity-100" : "opacity-0 pointer-events-none")}><VisualWrapper visual={district_2.mapVisual} className="size-full" visualClassName="size-full" imgClassName="object-cover" extraImageProps={{
          visualOrientation: "0"
        }} /></div> : null)}</div>;
    $[19] = districts;
    $[20] = hasMaps;
    $[21] = settledIndex;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== textColor) {
    t10 = cn("typography-body-md-medium", textColor);
    $[23] = textColor;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  const t11 = settledIndex + 1;
  let t12;
  if ($[25] !== t10 || $[26] !== t11 || $[27] !== total) {
    t12 = <span className={t10} data-testid="district-card-pagination">{t11}/{total}</span>;
    $[25] = t10;
    $[26] = t11;
    $[27] = total;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="ml-auto">{navigation}</div>;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t12) {
    t14 = <div className="flex w-full tablet:max-w-[358px] items-end justify-between">{t12}{t13}</div>;
    $[30] = t12;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t14 || $[33] !== t9) {
    t15 = <div className="flex w-full flex-col items-start gap-4 tablet:max-w-[358px] tablet:gap-6">{t9}{t14}</div>;
    $[32] = t14;
    $[33] = t9;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t15 || $[36] !== t8) {
    t16 = <div className="relative z-10 flex w-full flex-col justify-between items-start p-6 h-[450px] overflow-hidden tablet:h-[544px]">{t8}{t15}</div>;
    $[35] = t15;
    $[36] = t8;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== colour || $[39] !== t16) {
    t17 = <ColorBlock variant="rectangle-sm" color={colour} className="flex w-full -mt-px rounded-none rounded-b-sm mobile:mt-0 mobile:max-w-[390px] mobile:rounded-sm tablet:max-w-[421px] tablet:rounded-md" data-testid="district-card">{t16}</ColorBlock>;
    $[38] = colour;
    $[39] = t16;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t17 || $[42] !== t6) {
    t18 = <div data-testid="district-map-carousel" className="relative w-full overflow-hidden"><div className="flex flex-col mobile:relative mobile:aspect-[45/26] mobile:flex-row mobile:items-end mobile:overflow-clip mobile:px-16 mobile:py-12">{t6}{t17}</div></div>;
    $[41] = t17;
    $[42] = t6;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  return t18;
}
function _temp2(district_0) {
  return <CarouselItem key={district_0.key} className="basis-full pl-0">{district_0.backgroundImage ? <VisualWrapper visual={district_0.backgroundImage} asBackground={true} className="h-full w-full" visualClassName="h-full w-full object-cover" imgClassName="object-cover" /> : <div className="h-full w-full bg-surface-base-secondary" />}</CarouselItem>;
}
function _temp(district) {
  return !!district.mapVisual;
}